// 促销管理路由
export default {
    path: 'promotion',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '促销管理'},
    children: [{
        path: 'shareActivity',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/shareActivity/list',
        meta: { title: '分享活动'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/shareActivity/list.vue'),
            meta: {title: '分享活动列表'}
        },{
            path: 'auditDetail/:auditId',
            component: () => import('@/views/promotion/shareActivity/auditDetail.vue'),
            meta: {title: '分享活动审核详情', activePage: '/promotion/shareActivity/list'},
            props: true
        },{
            path: 'add',
            component: () => import('@/views/promotion/shareActivity/edit.vue'),
            meta: {title: '新增分享活动'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/promotion/shareActivity/edit.vue'),
            meta: {title: '编辑分享活动'},
            props: true
        },{
            path: 'joinedUser/:id',
            component: () => import('@/views/promotion/shareActivity/joinedUser.vue'),
            meta: {title: '参与用户'},
            props: true
        },{
            path: 'award/list',
            component: () => import('@/views/promotion/shareActivity/award/list.vue'),
            meta: {title: '奖品管理'},
        },{
            path: 'award/add/:shareActivityId',
            component: () => import('@/views/promotion/shareActivity/award/edit.vue'),
            meta: {title: '创建奖品'},
            props: true
        },{
            path: 'award/edit/:shareActivityId/:id',
            component: () => import('@/views/promotion/shareActivity/award/edit.vue'),
            meta: {title: '编辑奖品'},
            props: true
        }]
    },{
        path: 'showCoupon',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/showCoupon/list',
        meta: { title: '优惠券'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/showCoupon/list'),
            meta: {title: '优惠券列表'}
        },{
            path: 'usageDetails/:id',
            component: () => import('@/views/promotion/showCoupon/usageDetails'),
            meta: {title: '使用明细'}
        },{
            path: 'userProfile/:id',
            component: () => import('@/views/promotion/showCoupon/userProfile'),
            meta: {title: '使用明细'}
        },{
            path: 'redemptionDetail',
            component: () => import('@/views/promotion/showCoupon/redemptionDetail'),
            meta: {title: '兑换码明细'}
        }]
    }
	,{
	    path: 'eventList',
	    component: () => import('@/components/RouterView'),
	    redirect: '/promotion/eventList/list',
	    meta: { title: '活动列表'},
	    children: [{
	        path: 'list',
	        component: () => import('@/views/promotion/eventList/list'),
	        meta: {title: '活动列表'}
	    }]
	},{
        path: 'subscribe',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/subscribe/list',
        meta: { title: '申购管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/subscribe/list'),
            meta: {title: '申购管理列表'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/promotion/subscribe/edit'),
            meta: {title: '编辑申购'},
            props: true
        },{
            path: 'add',
            component: () => import('@/views/promotion/subscribe/edit'),
            meta: {title: '创建申购'}
        },{
            path: 'subscribeuser/:id',
            component: () => import('@/views/promotion/subscribe/subscribeuser'),
            meta: {title: '申购名单'},			
			props: true
        }]
    },{
        path: 'peripheralCoupon',
        component: () => import('@/views/promotion/peripheralCoupon'),
        meta: { title: '周边优惠券'},
    },{
        path: 'lottery',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/lottery/list',
        meta: { title: '幸运抽奖'},
        children:[{
            path: 'list',
            component: () => import('@/views/promotion/lottery/list'),
            meta: {title: '抽奖活动列表'}
        },{
            path: 'statistics',
            component: () => import('@/views/promotion/lottery/statistics'),
            meta: {title: '活动数据'}
        },{
            path: 'edit/:id/step1',
            component: () => import('@/views/promotion/lottery/edit/step1'),
            meta: {title: '活动编辑'},
            props: true
        },{
            path: 'edit/:id/step2',
            component: () => import('@/views/promotion/lottery/edit/step2'),
            meta: {title: '活动编辑'},
            props: true
        },{
            path: 'add/step1',
            component: () => import('@/views/promotion/lottery/edit/step1'),
            meta: {title: '创建活动'}
        },{
            path: 'prizeList/:id',
            component: () => import('@/views/promotion/lottery/prizeList'),
            meta: {title: '奖品信息'},
            props: true
        },{
            path: 'whiteList/:id',
            component: () => import('@/views/promotion/lottery/whiteList'),
            meta: {title: '白名单'},
            props: true
        }]
    },{
        path: 'expand',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/expand/list',
        meta: { title: '膨胀优惠券'},
        children:[{
            path: 'list',
            component: () => import('@/views/promotion/expand/list'),
            meta: {title: '膨胀优惠券列表'}
        },{
            path: 'add',
            component: () => import('@/views/promotion/expand/edit'),
            meta: {title: '创建活动'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/promotion/expand/edit'),
            meta: {title: '编辑活动'},
            props: true
        },{
            path: 'userList/:id',
            component: () => import('@/views/promotion/expand/userList'),
            meta: {title: '用户列表'},
            props: true
        },{
            path: 'dashboard/:id',
            component: () => import('@/views/promotion/expand/dashboard'),
            meta: {title: '活动数据'},
            props: true
        }]
    },{
        path: 'unlockPoster',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/unlockPoster/list',
        meta: { title: '解锁海报'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/unlockPoster/list'),
            meta: {title: '解锁海报活动列表'}
        },{
            path: 'add',
            component: () => import('@/views/promotion/unlockPoster/edit'),
            meta: {title: '创建解锁海报活动'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/promotion/unlockPoster/edit'),
            meta: {title: '编辑解锁海报活动'},
            props: true
        }]
    },{
        path: 'checkIn',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/checkIn/list',
        meta: { title: '现场打卡'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/checkIn/list'),
            meta: {title: '现场打卡活动列表'}
        },{
            path: 'add',
            component: () => import('@/views/promotion/checkIn/edit'),
            meta: {title: '创建现场打卡活动'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/promotion/checkIn/edit'),
            meta: {title: '编辑现场打卡活动'},
            props: true
        }]
    },{
        path: 'cps',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/cps/list',
        meta: { title: '抖音CPS通用计划'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/cps/list'),
            meta: {title: '计划列表'}
        },{
            path: 'details/:id',
            component: () => import('@/views/promotion/cps/details'),
            meta: {title: '计划管理'},
            props: true
        }]
    },{
        path: 'cps',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/cps/userList',
        meta: { title: '抖音CPS达人统计'},
        children: [{
            path: 'userList',
            component: () => import('@/views/promotion/cps/userList'),
            meta: {title: '抖音CPS达人统计列表'},
			props: true
        }]
    },{
        path: 'ops',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/ops/list',
        meta: { title: '抖音CPS定向计划'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/ops/list'),
            meta: {title: '计划列表'}
        },{
            path: 'add',
            component: () => import('@/views/promotion/ops/add'),
            meta: {title: '新建计划'}
        },{
            path: 'details/:id',
            component: () => import('@/views/promotion/ops/details'),
            meta: {title: '计划管理'},
            props: true
        },{
            path: 'update/:id',
            component: () => import('@/views/promotion/ops/update'),
            meta: {title: '修改计划'},
            props: true
        }]
    },{
        path: 'wenda',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/wenda/list',
        meta: { title: '有奖问答'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/wenda/list'),
            meta: {title: '有奖问答活动列表'}
        },{
            path: 'add',
            component: () => import('@/views/promotion/wenda/edit'),
            meta: {title: '创建有奖问答活动'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/promotion/wenda/edit'),
            meta: {title: '编辑有奖问答活动'},
            props: true
        },{
            path: 'userlist/:id',
            component: () => import('@/views/promotion/wenda/userlist'),
            meta: {title: '用户列表'},
            props: true
        }]
    },{
        path: 'instant',
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/instant/list',
        meta: { title: '随机立减'},
        children: [{
            path: 'list',
            component: () => import('@/views/promotion/instant/list'),
            meta: {title: '随机立减活动列表'}
        },{
            path: 'details/:id/:time',
            component: () => import('@/views/promotion/instant/details'),
            meta: {title: '立减活动数据'},
            props: true
        }]
    },{
        path: 'redbookgoods', ///promotion/instant/list
        component: () => import('@/components/RouterView'),
        redirect: '/promotion/redbookgoods/sort',
        meta: { title: '小红书专业号商品排序'},
        children: [{
            path: 'sort',
            component: () => import('@/views/promotion/redbookgoods/sort'),
            meta: {title: '小红书专业号商品排序列表'}
        }]
    }]
}